// 1、按需引入方法
import { createRouter, createWebHashHistory } from "vue-router";
// 2、定義一些路由
const routes = [
  // 每個路由都需要對映到一個元件
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Index-login.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/PageNotFound.vue"),
  },
  {
    path: "/workOrderHistory",
    name: "singleWorkOrderHistory",
    component: () => import("../views/Index-embedded.vue"),
    beforeEnter: (to, from, next) => {
      // 獲取參數
      const token = to.query.token;
      const uid = to.query.uid;
      console.log(token);
      console.log(uid);
      if (token == undefined || uid == undefined) {
        console.log("no access");
        next("/login");
      } else {
        next();
      }
    },
  },
  {
    path: "/demoPlugin",
    name: "demoPlugin",
    component: () => import("../views/Index-demoPlugin.vue"),
  },
];
//3、建立路由例項
const router = createRouter({
  routes,
  history: createWebHashHistory("./"),
});

export default router;
